var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('auth-guard',{attrs:{"route":""}},[_c('base-title',{attrs:{"title":"Create Yard"}}),_c('write-yard-info',{attrs:{"statuses":_vm.statuses},on:{"addYardInfo":_vm.createNewYard}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }